import { Module } from 'vuex-module-decorators';
import store from '@/store';
import FilterModule from '@/store/filter';

@Module({ dynamic: true, store, name: 'cancellationReasonsFilter', namespaced: true })
export default class CancellationReasonsFilter extends FilterModule {
    constructor(module: CancellationReasonsFilter) {
        super(module);
    }
}
